import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { fuseAnimations } from '@fuse/animations';

import { Note } from '../../../../shared/models/note';
import { NoteService } from '../../../../shared/services/note.service';
import { INote, IParentEntity } from 'app/shared/interfaces/entity';
import { MatDialog } from '@angular/material/dialog';
import { NoteDialogComponent } from '../note-dialog/note-dialog.component';
import { UserService } from 'app/shared/services/user.service';

@Component({
    selector: 'note-details',
    templateUrl: './note-details.component.html',
    styleUrls: ['./note-details.component.scss'],
    animations: fuseAnimations,
})
export class NoteDetailsComponent implements OnInit, OnDestroy {
    note: INote;
    labels: any[];
    editable = false;
    currentNote: INote;

    @Input() parent: IParentEntity;
    @Input() readOnly = false;

    onCurrentNoteChanged: Subscription;

    constructor(
        private dialog: MatDialog,
        private noteService: NoteService,
        private userService: UserService,
    ) {}

    ngOnInit() {
        // Subscribe to update the current note
        this.onCurrentNoteChanged =
            this.noteService.onCurrentNoteChanged
                .subscribe((currentNote) => {
                    this.currentNote = currentNote;
                    this.editable = currentNote && (!currentNote.sequenceId) 
                        && (currentNote.note.createdById && (currentNote.note.createdById === this.userService.getCurrentUserId()));
                    if (!currentNote) {
                        this.note = null;
                    }
                    else {
                        if (currentNote.note) {
                            this.note = currentNote;
                            this.note.note = new Note(currentNote.note);
                        }
                    }
                });
    }

    ngOnDestroy() {
        if (this.onCurrentNoteChanged) this.onCurrentNoteChanged.unsubscribe();
    }

    edit(){
        this.dialog.open(NoteDialogComponent, {
            data: {
              note: this.currentNote,
              parent: this.parent,
              readOnly: false,
            },
            disableClose: true,
            autoFocus: false,
          });
    }

    print(){
        this.noteService.print(this.parent, [this.currentNote]);
    }
}
